export default function AtcTimeService(userService) {
    'ngInject';

    const TIMEZONE_UK = 'Europe/London';
    const defaultDateFormat = 'YYYY-MM-DD';
    const atcApiDateFormat = 'DDMMYY';

    return {
        getUkTime,
        getDateInUserRegionFormat,
        getDateInUserRegionFormatOrCurrentDate,
        getSelectedMinutesOption,
        convertTimeToMilliseconds,
        parseAndFormat,
        parse,
        isToday,
        addDays,
        isSameDay,
        getDateNoTime,
        formatDate,
        parseAtcApiFormat,
    };

    function parseAndFormat(stringDate, dateFormatIn, dateFormatOut) {
        if (!stringDate) {
            return null;
        }
        return moment(stringDate, dateFormatIn || userService.getRegionalSettings().dateFormat)
            .format(dateFormatOut || defaultDateFormat);
    }

    function parse(stringDate, format) {
        return moment(stringDate, format || userService.getRegionalSettings().dateFormat);
    }

    function getDateInUserRegionFormat(inputDate) {
        const {dateFormat} = userService.getRegionalSettings();
        return moment(inputDate, dateFormat);
    }

    function getDateInUserRegionFormatOrCurrentDate(inputDate) {
        return inputDate ? getDateInUserRegionFormat(inputDate) : moment();
    }

    function parseAtcApiFormat(stringDate) {
        return moment(stringDate, atcApiDateFormat);
    }

    function convertTimeToMilliseconds(value) {
        return moment.duration(value).asMilliseconds();
    }

    function getUkTime() {
        return moment().tz(TIMEZONE_UK);
    }

    function getSelectedMinutesOption(timeOptions, minutes) {
        let index = 0;
        if ((minutes > 0) && (minutes <= 15)) {
            index = 1;
        } else if ((minutes > 15) && (minutes <= 30)) {
            index = 2;
        } else if ((minutes > 30) && (minutes <= 45)) {
            index = 3;
        } else if (minutes > 45) {
            index = 0;
        }
        return timeOptions[index];
    }

    function isToday(date) {
        const now = moment();
        return date.date() === now.date()
            && date.month() === now.month()
            && date.year() === now.year();
    }

    function isSameDay(date1, date2) {
        return date1.getDate() === date2.getDate()
            && date1.getMonth() === date2.getMonth()
            && date1.getFullYear() === date2.getFullYear();
    }

    function addDays(date, days) {
        const res = new Date(date);
        res.setDate(res.getDate() + days);
        return res;
    }

    function getDateNoTime(date) {
        const dateCopy = new Date(date);
        return new Date(dateCopy.getFullYear(), dateCopy.getMonth(), dateCopy.getDate(), 0, 0, 0, 0);
    }

    function formatDate(date, format) {
        return moment(date).format(format);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/services/atcTimeService.js